import {
  styled,
  Box,
  Tooltip,
  TooltipProps,
  tooltipClasses,
} from '@mui/material';

import {
  MultipleLinearProgressSize,
  MultipleLinearProgressBorderRadiusType,
} from './types';
import { getHeightBySize, getBorderRadiusByType } from './utils';

export const MultipleLinearProgresContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
}));

export const MultipleLinearProgresContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  alignItems: 'center',
}));

export const MultipleLinearProgresTooltip = styled(
  ({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ),
)({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 'none',
    fontSize: 10,
  },
});

interface MultipleLinearProgresBarProps {
  size: MultipleLinearProgressSize;
  borderRadiusType:
    | MultipleLinearProgressBorderRadiusType
    | MultipleLinearProgressBorderRadiusType[];
}

export const MultipleLinearProgresBar = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'size' && prop !== 'borderRadiusType',
})<MultipleLinearProgresBarProps>(({ theme, size, borderRadiusType }) => {
  const height = getHeightBySize(size);

  return {
    width: '100%',
    display: 'flex',
    height,
    borderRadius: getBorderRadiusByType(borderRadiusType, height / 2),
    backgroundColor: theme.palette.divider,
    overflow: 'hidden',
  };
});

export const MultipleLinearProgresSegment = styled(Box)({
  height: '100%',
});

export const MultipleLinearProgresLegendContainer = styled(Box)(
  ({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
    flexWrap: 'wrap',
  }),
);

export const MultipleLinearProgresLegendItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const MultipleLinearProgresLegendDot = styled(Box)({
  height: 14,
  width: 14,
  borderRadius: '50%',
  display: 'inline-block',
});

export const MultipleLinearProgresLegendLabelContainer = styled(Box)(
  ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
  }),
);
